import React from 'react';
import PropTypes from 'prop-types';

import MatchesItemType from './matchesItemType';
import MatchesSpinner from './MatchesSpinner';
import NoMatches from './NoMatches';
import MatchesTableInfinityScroll from './MatchesTableInfinityScroll';

const MatchesTable = (
  {
    columns,
    loadMoreMatches,
    matches,
    matchesInitialized,
    noMatches,
    selectable,
    status,
}) => {
  const showSpinner = !matchesInitialized;
  const canShowMatches = !showSpinner && !noMatches;

  return (
    <div className="vendor-matches-table">
      { showSpinner &&
        <MatchesSpinner />
      }
      { noMatches &&
        <NoMatches />
      }
      { canShowMatches && (
        <MatchesTableInfinityScroll
          columns={columns}
          loadMoreMatches={loadMoreMatches}
          matchesFromServer={matches}
          selectable={selectable}
          status={status}
        />
      )}
    </div>
  );
};

MatchesTable.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  selectable: PropTypes.bool,
  noMatches: PropTypes.bool.isRequired,
  loadMoreMatches: PropTypes.func.isRequired,
  matches: PropTypes.arrayOf(MatchesItemType).isRequired,
  matchesInitialized: PropTypes.bool.isRequired,
  status: PropTypes.string.isRequired,
};

MatchesTable.defaultProps = {
  selectable: false,
};

export default MatchesTable;
